import examAPI from "../examAPI";

export const getQuestions = ({
  params: { page, uuid, page_size } = {},
  signal,
} = {}) => {
  return new Promise((resolve, reject) => {
    try {
      examAPI
        .get(`/questions/questions/${uuid ? uuid : ""}`, { signal })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
// A question's detail. Besides the question it carries `version` (the latest version's number, or null; an edit
// sends it back as base_version) and `actions` ({edit, delete, resubmit, missing, ...}: what the user may do
// with it now). Older backends send neither.
export const getQuestionDetail = (uuid, { signal } = {}) =>
  examAPI.get(`/questions/questions/${uuid}/`, { signal }).then((res) => res?.data);

export const getDraftQuestion = ({ params: { uuid } = {}, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      examAPI
        .get(`/questions/questions/${uuid}/get_draft`, {
          signal,
        })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

// One question or a list. Into an exam's subject only complete questions go, all or none: 400 incomplete with
// items: [{index, missing}] (index: the position in the list sent, 0 for one question).
export const postSaveQuestion = (body) => {
  return new Promise((resolve, reject) => {
    try {
      examAPI
        .post(`/questions/questions/`, body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

// An edit, or a draft's submit. `body.base_version` (optional): the version the form was opened on; a question
// changed since answers 409 stale_version. The answer carries the new `version`.
export const patchEditQuestion = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      examAPI
        .patch(`/questions/questions/${uuid}/`, body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const deleteQuestion = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      examAPI
        .delete(`/questions/questions/${uuid}/`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postSaveQuestionAsDraft = (body) => {
  return new Promise((resolve, reject) => {
    try {
      examAPI
        .post(`/questions/questions/save_draft/`, body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
